module.exports = __webpack_public_path__ + "img/defaultIssueMarker.0a3bcdef.svg";